export const translation = {
  system: 'bus2-client',
  namespaces: ['common', 'modules', 'bus-shared', 'bus-client'],
  URL: process.env.REACT_APP_TRANSLATOR_URL || '/translator'
}



// WEBPACK FOOTER //
// ./src/consts/index.js